var map = {
	"./AdmitCardHeader.vue": 46584,
	"./AppLogo.vue": 63580,
	"./Institution.vue": 80122,
	"./SAddressForm.vue": 48046,
	"./SAvatar.vue": 21702,
	"./SBtn.vue": 16682,
	"./SCamera.vue": 94828,
	"./SConfirmDialog.vue": 21802,
	"./SDeleteDialog.vue": 2102,
	"./SDialog.vue": 8304,
	"./SDocumentDialog.vue": 94070,
	"./SFileUploader.vue": 1738,
	"./SForm.vue": 79711,
	"./SImageUploader.vue": 29422,
	"./SImg.vue": 2513,
	"./SMenu.vue": 55385,
	"./SNotification.vue": 54564,
	"./SPasswordChange.vue": 55966,
	"./SReportFilterBar.vue": 5068,
	"./SReportTable.vue": 56352,
	"./SSelect.vue": 72913,
	"./SStaffSelect.vue": 37209,
	"./STable.vue": 14120,
	"./STestUploader.vue": 12842,
	"./STextArea.vue": 33352,
	"./STextField.vue": 96009,
	"./STimetableGrid.vue": 40820,
	"./SUploader.vue": 827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56409;